<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Employee Users Module</h4>
			</div>
			<div class="card-body">
				<h3 class="text-danger">{{ msgError }}</h3>

				<div class="row">
					<div class="col-12">
						<button type="button" class="btn btn-success btn-label waves-effect right waves-light rounded-pill me-2" data-bs-toggle="modal" data-bs-target=".exampleModalFullscreen" (click)="openCreateUserModal(addEmployeeUserModal)">
							<i class="ri-add-circle-fill label-icon align-middle rounded-pill fs-16 ms-2"></i>
							Add new Employee
						</button>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col-lg-12">
						<form class="content-filters">
							<div class="row mt-2">
								<div class="form-group col-sm-2">
									<label for="filterAlias" class="headerSearch">Select Status</label>
									<div ngbDropdown>
										<button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>
											{{ filterClient }}
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
											<button ngbDropdownItem (click)="getEmployeeUsers(1)">Active</button>
											<button ngbDropdownItem (click)="getEmployeeUsers(0)">Inactive</button>
										</div>
									</div>
								</div>
								<div class="form-group col-sm-2">
									<label for="filterFirst" class="headerSearch">Name</label>
									<input #Name type="text" class="form-control" id="filterFirst" placeholder="Filter by name" (keyup)="updateFilter($event, 2)" />
								</div>
								<div class="form-group col-sm-2">
									<label for="filterLogin" class="headerSearch">Login</label>
									<input #Login type="text" class="form-control" id="filterLogin" placeholder="Filter by login" (keyup)="updateFilter($event, 1)" />
								</div>
								<div class="form-group col-sm-2" style="padding-top: 30px">
									<button class="btn btn-success" (click)="cleanFiltersSearch()"><i class="fa fa-hand-pointer-o"></i>Clear</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<br />
				<div *ngIf="!loading">
					<div class="card-body">
						<ngx-datatable class="table-responsive table-card material striped" [rows]="employeeUsers" [columns]="columns" [loadingIndicator]="loading" [columnMode]="columnMode.force" [headerHeight]="50" [footerHeight]="70" rowHeight="auto" [reorderable]="reorderable" [scrollbarH]="true">
							<ngx-datatable-column prop="isActive" name="Active" headerClass="bg-light" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center" class="form-check form-switch">
										<input *ngIf="row['isActive'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="deactivateUserConfirm(row)" />
										<input *ngIf="row['isActive'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="activateUserConfirm(row)" />
									</div>
									<!-- <i *ngIf="row['isActive'] == 1" placement="right" ngbTooltip="Deactivate User" (click)="deactivateUserConfirm(row)" class="fa fa-lg fa-check-square-o"></i>
									<i *ngIf="row['isActive'] == 0" placement="right" ngbTooltip="Activate User" (click)="activateUserConfirm(row)" class="fa fa-lg fa-square-o"></i> -->
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="isAdmin" name="Admin" headerClass="bg-light" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center" class="form-check form-switch form-switch-danger">
										<input *ngIf="row['isAdmin'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="deactivateUserAdminConfirm(row)" />
										<input *ngIf="row['isAdmin'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="activateUserAdminConfirm(row)" />
										<!-- <i *ngIf="row['isAdmin'] == 1" placement="right" ngbTooltip="Deactivate Admin Role" checked (click)="deactivateUserAdminConfirm(row)" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2"></i>
										<i *ngIf="row['isAdmin'] == 0" placement="right" ngbTooltip="Activate Admin Role" (click)="activateUserAdminConfirm(row)" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2"></i> -->
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="isDbReset" name="Db Reset" headerClass="bg-light" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center" class="form-check form-switch form-switch-danger">
										<input *ngIf="row['isDbReset'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="deactivateDbResetConfirm(row)" />
										<input *ngIf="row['isDbReset'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="activateDbResetConfirm(row)" />
										<!-- <i *ngIf="row['isDbReset'] == 0" placement="right" ngbTooltip="Activate DB Reset" (click)="activateDbResetConfirm(row)" class="fa fa-lg fa-square-o"></i>
										<i *ngIf="row['isDbReset'] == 1" placement="right" ngbTooltip="Deactivate DB Reset" (click)="deactivateDbResetConfirm(row)" class="fa fa-lg fa-check-square-o"></i> -->
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="isCaller" name="Is Caller" headerClass="bg-light" [width]="30">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center" class="form-check form-switch form-switch-danger">
										<input *ngIf="row['isCaller'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="deactivateCaller(row)" />
										<input *ngIf="row['isCaller'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="activateCaller(row)" />
										<!-- <i *ngIf="row['isCaller'] == 0" placement="right" ngbTooltip="Activate Caller" (click)="activateCaller(row)" class="fa fa-lg fa-square-o"></i>
										<i *ngIf="row['isCaller'] == 1" placement="right" ngbTooltip="Deactivate Caller" (click)="deactivateCaller(row)"  class="fa fa-lg fa-check-square-o" ></i> -->
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column prop="name" name="Name" headerClass="bg-light" [width]="150"></ngx-datatable-column>
							<ngx-datatable-column prop="login" headerClass="bg-light center" [width]="50">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center" class="pointer" (dblclick)="openEditUserModal(addEmployeeUserModal, row)">
										<span class="badge bg-primary">{{ row["login"] }}</span>
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="email1" name="Email" headerClass="bg-light" [width]="100"></ngx-datatable-column>

							<ngx-datatable-column prop="email1" name="Password" headerClass="bg-light" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div class="pointer" align="center" *ngIf="showPass !== row.id" (click)="showPass = row.id">***** <i class="ri-eye-line"></i></div>
									<div class="pointer" align="center" *ngIf="showPass === row.id" (click)="showPass = -1">{{ getUserPass(row.name) }} <i class="ri-eye-off-line"></i></div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Ring Central Ext" headerClass="bg-light" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center">
										<div>
											{{ row.ringcentral_ext }} <span *ngIf="row.rc_ext_id !== '' && row.rc_ext_id != undefined"><i class="ri-check-line icon-check"></i></span><span *ngIf="row.rc_ext_id == '' || row.rc_ext_id == undefined"><i class="ri-close-line icon-close"></i></span>
										</div>
										<div *ngIf="row.rc_ext_id == '' || row.rc_ext_id == undefined"><button class="btn btn-danger btn-sm" ngbTooltip="Delete Ring Central Ext" (click)="getRingCentralExtension(row)">Validate Ext</button></div>
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Email" headerClass="bg-light" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div align="center">
										<div>
											<button class="btn btn-danger btn-sm" ngbTooltip="Send Password creation email" (click)="sendPasswordEmployeeCreation(row.email1, row.name)">Send Password</button>
										</div>
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-footer *ngIf="true">
								<ng-template ngx-datatable-footer-template let-rowCount="rowCount">
									<div class="title-footer" style="margin-left: 5px">
										<strong>Total Records: </strong>
										{{ rowCount }}
									</div>
								</ng-template>
							</ngx-datatable-footer>
						</ngx-datatable>
					</div>
				</div>
			</div>

			<!--end col-->
		</div>
		<!--end row-->
	</div>
</div>

<!-- Modals -->
<ng-template #addEmployeeUserModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">{{ editUserMode ? "Edit employee user" : "Create employee user" }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="createEmployeeUserForm">
			<div class="container">
				<div class="row">
					<div class="col-6">
						<label for="name">Name</label>
						<input type="text" class="form-control is-valid" formControlName="name" placeholder="Name" [ngClass]="utils.validateInput('name', createEmployeeUserForm)" />
					</div>
					<div class="col-6">
						<label for="lastname">Lastname</label>s
						<input type="text" class="form-control" formControlName="lastname" placeholder="Lastname" [ngClass]="utils.validateInput('lastname', createEmployeeUserForm)" />
					</div>
				</div>
				<div class="row">
					<div class="col-7">
						<label for="email">T3 Direct Email</label>
						<input type="email" class="form-control" formControlName="email" placeholder="T3 Direct Email" [ngClass]="utils.validateInput('email', createEmployeeUserForm)" />
					</div>
					<div class="col-5">
						<label for="email">Ring Central Extension</label>
						<input type="number" class="form-control" formControlName="ringcentral_ext" placeholder="Example: 102" [ngClass]="utils.validateInput('ringcentral_ext', createEmployeeUserForm)" />
					</div>
				</div>
				<div class="row">
					<div class="col-3">
						<label for="">Admin</label>
						<div align="center" class="form-check form-switch form-switch-danger">
							<input class="form-check-input" type="checkbox" formControlName="isAdmin" role="switch" />
						</div>
					</div>
					<div class="col-3">
						<label for="">Caller</label>
						<div align="center" class="form-check form-switch form-switch-danger">
							<input class="form-check-input" type="checkbox" formControlName="isCaller" role="switch" />
						</div>
					</div>
					<div class="col-6">
						<label for="">Access to Database Reset?</label>
						<div align="center" class="form-check form-switch form-switch-danger">
							<input class="form-check-input" type="checkbox" formControlName="isDbReset" role="switch" />
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="validateAndSubmit()" *ngIf="!editUserMode">Create user</button>
		<button type="button" class="btn btn-outline-secondary" (click)="updateEmployeeUser()" *ngIf="editUserMode">Update user</button>
	</div>
</ng-template>
